export default __webpack_public_path__ + "956450eda38516c3267b888f85d06b35.png";